export const NOTICES_BASE_PATH = '/notices';
export const NOTICES_BACKEND_PLUGIN_ID = 'neo4j-notices';
